"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.carbonRegionResourceId = void 0;
const string_1 = require("./utils/string");
/**
 * Construct the resourceId for selected carbon data
 * @param carbonRegion Region code
 * @param carbonMix Mix (select energy source)
 * @returns resourceId for selected carbon data
 */
function carbonRegionResourceId(carbonRegion, carbonMix) {
    return ("20211101-a1a1-0001-" +
        (0, string_1.padStart)(carbonRegion.toString(16), 4, "0") +
        "-" +
        (0, string_1.padStart)(carbonMix.toString(16), 12, "0"));
}
exports.carbonRegionResourceId = carbonRegionResourceId;
//# sourceMappingURL=carbon.js.map